import { css } from "@emotion/css";

type Props = {
  children: React.ReactNode;
};

export function NavigationSection(props: Props) {
  return <section className={navigationStyles}>{props.children}</section>;
}
export const navigationStyles = css({
  paddingLeft: "var(--space-3)",
  paddingRight: "var(--space-3)",
});
